module.exports = __webpack_public_path__ + "static/mindswarms-color-a8f2bc33df71db63d4364cfc3ff2d203.webp";